<template>
  <div>
    <div class="card overflow-hidden">
      <div
        v-if="previewData"
        class="card-body"
      >
        <div
          v
          class="row"
        >
          <div class="col-lg-5">
            <ProductGalleryView
              :images="pImages"
              class="mt-2"
            />
          </div>
          <div class="col-lg-7">
            <div class="font-size-24 font-weight-bold text-dark mb-2">
              <span> {{ previewData.offer.price | currency }}<small>UZS</small> </span>
              <del class="align-text-top font-size-14"> {{ previewData.offer.price | currency }}<small>UZS</small></del>
            </div>
            <div class="pb-3 mb-4 border-bottom">
              <a
                href="javascript:void(0);"
                class="text-blue font-size-18"
              >
                {{ $l(previewData.title) }}
              </a>
            </div>
            <div class="d-flex align-items-center mb-2">
              <ul class="product_param">
                <li>{{ $t('product.code') }}: {{ previewData.offer.code }}</li>
                <li>
                  <a-rate
                    :default-value="previewData.offer.rating"
                    disabled
                    allow-half
                  />
                  <span>(5)</span>
                </li>
              </ul>
            </div>
            <a
              href="javascript: void(0);"
              class="width-200 btn btn-success btn-with-addon mr-auto mb-3 text-nowrap d-none d-md-block"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-plus-circle" />
              </span>
              Добавить в корзину
            </a>
            <div class="product-info-list mt-4">
              <ul>
                <li><strong class="mr-2">Доставка:</strong> 0.00 UZS</li>
                <li><strong class="mr-2">Самовывоз:</strong> 0.00 UZS</li>
                <li>
                  <strong class="mr-2">Продавец:</strong>
                  <a href="#">{{ $l(previewData.offer.seller.title) }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="cui__utils__heading mt-4 mb-4">
          <h5>Описание товара</h5>
        </div>
        <div class="product_desc block-w p-20 mb-30">
          <div
            v-for="attrKey in attributeKeys"
            :key="attrKey"
            class="pp"
          >
            <span><b>{{ $l(attributesTitle[attrKey]) }}</b></span><span>{{ stringifyAttributes(attributesMap[attrKey]) }}</span>
          </div>
        </div>
      </div>
      <div
        v-else
        class="card-body"
      >
        <a-row
          type="flex"
          justify="center"
        >
          <a-col :span="1">
            <a-spin />
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import ProductGalleryView from '@/components/product/preview/ProductGalleryView'
import productService from '@/services/api/manager/product-service'

export default {
  name: 'ProductPreview',
  components: {
    ProductGalleryView,
  },
  props: {
    variationId: {
      type: String,
      default () {
        return null
      },
    },
    isCompanyProduct: {
      type: Boolean,
      default () {
        return undefined
      },
    },
  },
  data () {
    return {
      pImages: [],
      previewData: null,
      favorite: true,
      activeImgIndex: 0,
      attributesMap: {},
      attributesTitle: {},
      attributeKeys: [],
    }
  },
  async beforeMount() {
    const productId = this.variationId || this.$route.params.id
    const isCompanyProduct = this.isCompanyProduct === undefined
      ? this.$route.query.isCompanyProduct
      : this.isCompanyProduct
    const { data } = await productService.previewProduct(productId, isCompanyProduct)
      .catch(() => {})

    this.previewData = data?.content ?? null
    const attributesMap = this.attributesMap
    const attributesTitle = this.attributesTitle

    if (this.previewData) {
      this.previewData.attributes.forEach((attr) => {
        if (attributesMap[attr.key] != null)
          attributesMap[attr.key].push(attr.title)
        else
          attributesMap[attr.key] = [attr.title]

        if (attributesTitle[attr.key] == null && attr.key_title) {
          attributesTitle[attr.key] = attr.key_title
        }
      })

      this.pImages = this.previewData.images
    }

    this.attributeKeys = Object.keys(this.attributesMap)
  },
  methods: {
    setImage (index) {
      this.activeImgIndex = index
    },
    stringifyAttributes (attributes) {
      return attributes.map(title => this.$l(title)).reduce((total, curr) => total + ' / ' + curr)
    },
  },
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
